module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAARNJREFUSA1jfK2g/p9hEAKmQegmsJNGHUZqzLCQqgFdPZuvNwO7qzOK8M/dexl+bd6KIkYqh2KHsWhqMLD7eqHY+/fJU4odNprGUIKUCM6gDTGS0hi7nw8Di6kxin9ZjQxQ+CAOm501AyMvD4r4n9NnGX5u2oIiho9DksNYzU0ZOKLC8ZkHlmPR1mIAYWTwg4mJJIcN2qgcdRhytBLDJimN/dy1h+Hv02co5rLZ2TCA0h4y+H3yNMOvQ0eQhRj+XL2GwifEIclhvw8eZgBhZMDIw4PpsHMXGL5Pm4msjGT2aBojNcgGbYiRlMaw+fr3qdMM35hR/QcSoxQwjrb5SQxC1DggUTMtlbMwMjI8pqUF5JoNAON7PBhH3aG6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Switzerland.png
// module id = 492
// module chunks = 7